import React from "react";
import { Helmet } from "react-helmet-async";
import BaseRatesContainer from "./BaseRatesContainer";
import { useTranslation } from "react-i18next";

import { StyledContentWrapper } from "../../styles/styledMain";

const BaseRatesTabsContainer = ({ match }) => {
  const { t } = useTranslation("baseRatesPage");

  return (
    <>
      <Helmet>
        <title>{t("meta.title")}</title>
      </Helmet>
      <StyledContentWrapper>
        <BaseRatesContainer match={match} />
      </StyledContentWrapper>
    </>
  );
};

export default BaseRatesTabsContainer;